import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the table view for providers.
 * @extends JetView
 */
export default class tableProvidersView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date format function
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'datatable', // DataTable view
                            id: 'datatable', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    template: function (obj) {
                                        // Template function for rendering
                                        if (devConfig.getPermAction('ProvidersEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon if permission granted
                                        } else {
                                            return ''; // No icon if permission denied
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: _('Proveedor Id'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Name', // Column ID
                                    header: _('Nombre'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Type', // Column ID
                                    header: _('Tipo'), // Localized column header
                                    width: 60, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IsActivate', // Column ID
                                    header: _('Estado'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IsVerified', // Column ID
                                    header: _('Verificado'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Abbreviated', // Column ID
                                    header: _('Abreviado'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Image', // Column ID
                                    header: _('Imagen'), // Localized column header
                                    width: 570, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handler for click events
                                edit: function (euv, id) {
                                    // Edit action
                                    $$('editwinProviders').show(); // Show edit window
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and binds events.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the datatable
        var url = devConfig.geturlApi() + 'Providers/GetProviders'; // API URL for fetching providers
        var filter = ''; // Filter string for data loading
        var popup = webix.ui({
            // Popup window for editing providers
            view: 'window',
            id: 'editwinProviders', // ID for the edit window
            width: screen.width < 500 ? 350 : 450, // Width based on screen size
            height: screen.width < 500 ? 670 : 490, // Height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Editar Proveedor') }, // Label for the window
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            // Close action
                            this.getTopParentView().hide(); // Hide the window
                        },
                    },
                ],
            },
            position: 'center', // Center the window
            modal: true, // Modal window
            body: {
                view: 'scrollview', // Scrollable body
                scroll: 'y', // Vertical scrolling
                body: {
                    view: 'form', // Form for editing provider details
                    id: 'editform', // ID for the edit form
                    width: screen.width < 500 ? 350 : 450, // Width based on screen size
                    height: screen.width < 500 ? 670 : 420, // Height based on screen size
                    elements: [
                        // Form elements
                        {
                            view: 'text', // Text input for ID
                            label: 'Id',
                            name: 'Id',
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'text', // Text input for Name
                            label: _('Nombre'),
                            name: 'Name',
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'text', // Text input for Type
                            label: _('Tipo'),
                            name: 'Type',
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'combo', // Combo box for IsActivate
                            label: _('Estado'),
                            name: 'IsActivate',
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'combo', // Combo box for IsVerified
                            label: _('Verificado'),
                            name: 'IsVerified',
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'text', // Text input for Abbreviated
                            label: _('Abreviado'),
                            name: 'Abbreviated',
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'text', // Text input for Image
                            label: _('Imagen'),
                            name: 'Image',
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                        },
                        {
                            margin: 10, // Margin for the next element
                            cols: [
                                {
                                    view: 'text', // Text input for Note
                                    labelPosition: 'top', // Label position
                                    label: _('Explicación'),
                                    name: 'Note',
                                    labelWidth: 160, // Label width
                                    attributes: { type: 'text' }, // Input attributes
                                },
                            ],
                        },
                        {
                            cols: [
                                // Button actions
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'),
                                    click: function () {
                                        // Cancel action
                                        this.getTopParentView().hide(); // Hide the window
                                    },
                                },
                                {
                                    view: 'button', // Save button
                                    type: 'form',
                                    value: _('Guardar'),
                                    click: function ($e) {
                                        // Save action
                                        var values = $$('editform').getValues(); // Get form values
                                        webix
                                            .ajax() // AJAX request to update provider details
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Provider/UpdateProviderDetails',
                                                '{"Id":' +
                                                    values.Id +
                                                    ',"IsActivate":"' +
                                                    values.IsActivate +
                                                    '","IsVerified":"' +
                                                    values.IsVerified +
                                                    '","Name":"' +
                                                    values.Name +
                                                    '","Abbreviated":"' +
                                                    values.Abbreviated +
                                                    '","Note":"' +
                                                    values.Note +
                                                    '","Image":"' +
                                                    values.Image +
                                                    '"}',
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Cell value was changed', // Success message
                                                        );
                                                        grid.clearAll(); // Clear the grid
                                                        grid.load(
                                                            url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                        );
                                                    },
                                                },
                                            );
                                        $$('editform').setValues(
                                            $$('editform').getCleanValues(), // Reset form values
                                        );
                                        this.getTopParentView().hide(); // Hide the window
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        var popupAdd = webix.ui({
            // Popup window for adding providers
            view: 'window',
            id: 'AddProviders', // ID for the add window
            width: screen.width < 500 ? 350 : 450, // Width based on screen size
            height: screen.width < 500 ? 600 : 400, // Height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Añadir Proveedor') }, // Label for the window
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            // Close action
                            this.getTopParentView().hide(); // Hide the window
                        },
                    },
                ],
            },
            position: 'center', // Center the window
            modal: true, // Modal window
            body: {
                view: 'scrollview', // Scrollable body
                scroll: 'y', // Vertical scrolling
                body: {
                    view: 'form', // Form for adding provider details
                    id: 'addform', // ID for the add form
                    width: screen.width < 500 ? 350 : 450, // Width based on screen size
                    height: screen.width < 500 ? 600 : 300, // Height based on screen size
                    elements: [
                        // Form elements
                        {
                            view: 'text', // Text input for Name
                            label: _('Nombre'),
                            name: 'Name',
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'combo', // Combo box for Type
                            label: _('Tipo'),
                            name: 'Type',
                            options: [
                                // Options for the combo box
                                { id: '1', value: 'CASINO' },
                                { id: '2', value: 'LIVECASINO' },
                                { id: '3', value: 'PAYMENT' },
                                { id: '5', value: _('PAYOUT') },
                                { id: '6', value: _('SPORT') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'combo', // Combo box for IsActivate
                            label: _('Estado'),
                            name: 'IsActivate',
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'combo', // Combo box for IsVerified
                            label: _('Verificado'),
                            name: 'IsVerified',
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'text', // Text input for Abbreviated
                            label: _('Abreviado'),
                            name: 'Abbreviated',
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'text', // Text input for Image
                            label: _('Imagen'),
                            name: 'Image',
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                        },
                        {
                            cols: [
                                // Button actions
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'),
                                    click: function () {
                                        // Cancel action
                                        this.getTopParentView().hide(); // Hide the window
                                        $$('addform').setValues(
                                            $$('addform').getCleanValues(), // Reset form values
                                        );
                                    },
                                },
                                {
                                    view: 'button', // Save button
                                    type: 'form',
                                    value: _('Guardar'),
                                    click: function ($e) {
                                        // Save action
                                        var values = $$('addform').getValues(); // Get form values
                                        webix
                                            .ajax() // AJAX request to add provider details
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Provider/UpdateProviderDetails',
                                                '{"Type":"' +
                                                    values.Type +
                                                    '", "IsActivate":"' +
                                                    values.IsActivate +
                                                    '","IsVerified":"' +
                                                    values.IsVerified +
                                                    '","Name":"' +
                                                    values.Name +
                                                    '","Abbreviated":"' +
                                                    values.Abbreviated +
                                                    '","Image":"' +
                                                    values.Image +
                                                    '"}',
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Cell value was changed', // Success message
                                                        );
                                                        grid.clearAll(); // Clear the grid
                                                        grid.load(
                                                            url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                        );
                                                    },
                                                },
                                            );
                                        $$('addform').setValues(
                                            $$('addform').getCleanValues(), // Reset form values
                                        );
                                        this.getTopParentView().hide(); // Hide the window
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        this.on(this.app, 'addProvider:button', (filter) => {
            // Event listener for adding provider
            popupAdd.show(); // Show add provider window
        });
        this.on(this.app, 'providers:filter', (filterData) => {
            // Event listener for filtering providers
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter data
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle datepicker filter
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format date
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format date
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter variable
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event handler for sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event handler for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        grid.attachEvent('onItemDblClick', function (id, e, node) {
            // Event handler for item double click
            var item = this.getItem(id); // Get double-clicked item
            popup.show(); // Show edit window
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event listener for player selection
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
        $$('editform').bind($$('datatable')); // Bind edit form to datatable
    }
}

// FILE DOCUMENTED
